import type { Theme } from '@mui/material';
// import type { Components } from '@mui/material/styles';

export const CUSTOM_ATTRIBUTE_MARGIN = 'data-0';

export default function MUIDialogContent(theme: Theme) /* : Components['MuiDialogContent'] */ {
  return {
    // defaultProps: {},
    variants: [
      {
        props: { [CUSTOM_ATTRIBUTE_MARGIN]: 'none' },
        style: {
          padding: '0 !important',
        },
      },
    ],
    styleOverrides: {
      root: {
        padding: theme.spacing(6),
        color: theme.palette.text.primary,
        borderTop: 0,
        borderBottom: 0,
      },
    },
    // variants: [],
  };
}
